mutation UpdateComplianceRecord($id: ID!, $input: UpdateComplianceRecordInput!) {
  updateComplianceRecord(id: $id, input: $input) {
    id
    contentId
    productId
    kind
    performerName
    note
    url
    fileName
    fileUrl
    createdAt
    updatedAt
  }
}
